import {
  enrollmentsLocaleEn,
  enrollmentsLocaleEs,
  enrollmentsLocalePt,
} from '../Enrollments/i18n';
import {
  savedCoursesEn,
  savedCoursesEs,
  savedCoursesPt,
} from '../SavedCourses/i18n';

export const routesLocalesEs = {
  ...enrollmentsLocaleEs.es,
  ...savedCoursesEs,
};
export const routesLocalesPt = {
  ...enrollmentsLocalePt.pt,
  ...savedCoursesPt,
};

export const routesLocalesEn = {
  ...enrollmentsLocaleEn.en,
  ...savedCoursesEn,
};
